import API, { handleRequest } from "@/api/lib/api";

export const getTillDevicesForOrderAccess = async () =>
  handleRequest(() => API.get("restaurant/devices/tills"));

export const updateTillOrderAccessSetting = async (restaurantId, payload) =>
  handleRequest(() =>
    API.put(`online-order/settings/restaurant/${restaurantId}/till-order-access`, payload),
  );
